import React, { createContext, useContext } from 'react';
import messages from './cabinetMessages';
import { getUiLocale, uiText } from './uiText';

const Context = createContext(null);
export const useCabinetLocale = () => useContext(Context) || getUiLocale();
export function useCabinetText() {
  const locale = useCabinetLocale();
  return text => locale === 'ru' || typeof text !== 'string' ? text : (messages[text]?.[locale] || uiText(text, {}, locale));
}
export function CabinetLocale({ locale, children }) {
  return <Context.Provider value={['ru', 'en', 'az'].includes(locale) ? locale : 'ru'}>{children}</Context.Provider>;
}
